<template>
  <a-popover>
    <template #content>
      <a-button
        size="small"
        style="margin: 10px 5px"
        :type="refreshType === '手动' ? 'primary' : 'default'"
        @click="selectRefreshType('手动')"
      >
        {{ $t('手动刷新') }}
      </a-button>
      <a-dropdown class="dropdown">
        <a-button
          size="small"
          style="margin: 10px 5px"
          :type="refreshType === '手动' ? 'default' : 'primary'"
        >
          {{ $t('自动刷新') }}
          <span v-if="refreshType !== '手动'">({{ refreshType }})</span>
        </a-button>
        <template #overlay>
          <a-menu>
            <a-menu-item>
              <a
                href="javascript:;"
                @click="selectRefreshType('5s')"
              >
                5s
              </a>
            </a-menu-item>
            <a-menu-item>
              <a
                href="javascript:;"
                @click="selectRefreshType('10s')"
              >
                10s
              </a>
            </a-menu-item>
            <a-menu-item>
              <a
                href="javascript:;"
                @click="selectRefreshType('30s')"
              >
                30s
              </a>
            </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
    </template>
    <reload-outlined
      v-if="refreshType === '手动'"
      @click="refresh"
    />
    <loading-outlined v-if="(countdown == -1 || loading) && refreshType !== '手动'" />
    <span v-if="countdown >= 0 && !loading">{{ countdown + 1 }}s</span>
  </a-popover>
</template>

<script lang="ts">
import { defineComponent, ref, onActivated, onDeactivated, onUnmounted, watch } from 'vue';
import { LoadingOutlined, ReloadOutlined } from '@ant-design/icons-vue';
export default defineComponent({
  name: 'refreshTypeModal',
  props: {
    refreshType: {
      type: String,
      default: () => '手动',
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
    LoadingOutlined,
    ReloadOutlined,
  },
  emits: ['refresh', 'typeChange'],
  setup(props, { emit }) {
    let init = false;
    const countdown: any = ref(0);
    const current_page: any = ref(true);

    // 刷新模式切换
    const selectRefreshType = (type: any) => {
      emit('typeChange', type);
      countdown.value = -1;
      if (props.refreshType == '手动') {
        emit('refresh');
      }
    };
    const timer_countdown = setInterval(() => {
      if (countdown.value < 0) {
        switch (props.refreshType) {
          case '手动':
            countdown.value = -1;
            break;
          case '5s':
            countdown.value = 4;
            break;
          case '10s':
            countdown.value = 9;
            break;
          case '30s':
            countdown.value = 29;
        }
      } else if (countdown.value == 0) {
        if (current_page.value && !props.loading && init) {
          emit('refresh', true);
        }
        countdown.value = -1;
      } else {
        countdown.value--;
      }
    }, 1000);

    watch(
      () => props.loading,
      () => {
        if (!props.loading) {
          countdown.value = -1;
          init = true;
        }
      },
    );

    onActivated(() => {
      if (!current_page.value) {
        current_page.value = true;
      }
    });
    onDeactivated(() => {
      current_page.value = false;
    });

    onUnmounted(() => {
      clearInterval(timer_countdown);
    });

    const refresh = () => {
      emit('refresh');
    };
    return {
      props,
      countdown,
      refresh,
      selectRefreshType,
    };
  },
});
</script>
